import { Image, View } from "react-native";
import { IStepComponentProps } from "@shared/components/form/types";
import { Text } from "@shared/components/text";
import { useTranslation } from "react-i18next";
import { VideoViewer } from "@shared/components/VideoViewer";
import { useAuth } from "app/auth/hooks/useAuth";
import { ActivityName } from "app/_modules/core/types";

export interface IMeasurementIntroStepContext {
  activityName?: ActivityName;
  activityId?: string;
}

export const MeasurementIntroStep = ({ context }: IStepComponentProps<undefined, IMeasurementIntroStepContext>) => {
  const { meData } = useAuth();
  const { t: strictT } = useTranslation();

  const activityName = context?.activityName;
  const vitalParameterData = meData?.current_pathway.vital_parameters.find((vitalParameter) => vitalParameter.vital_parameter.name === activityName);

  const tutorialMediaUrl = vitalParameterData?.device_vital_parameter.tutorial_media_url;
  const tutorialSteps = vitalParameterData?.device_vital_parameter.tutorial_steps
    ?.split('\n')
    .map((step) => step.trim().replace(/^\d+[\.\)]\s*/, ''))
    .filter(Boolean);
  const isImage = !!tutorialMediaUrl?.includes('.png');

  return (
    <View className="flex-col gap-4 mt-4">
      {tutorialMediaUrl && (
        isImage ? (
          <View className="w-full rounded-2xl overflow-hidden bg-black" style={{ height: 300 }}>
            <Image source={{ uri: tutorialMediaUrl }} style={{ width: '100%', height: '100%' }} resizeMode="contain" />
          </View>
        ) : (
          <View className="w-full rounded-2xl overflow-hidden" style={{ aspectRatio: 16 / 9 }}>
            <VideoViewer
              videoUrl={tutorialMediaUrl}
              style={{ width: '100%', height: '100%' }}
              resizeMode="contain"
              controls={true}
              paused={false}
              repeat={true}
            />
          </View>
        )
      )}

      {!!tutorialSteps?.length && (
        <View className="flex-col gap-3">
          <Text className="text-md font-semibold text-gray-500" style={{ letterSpacing: 1 }}>
            {strictT("measurement.howToLabel").toUpperCase()}
          </Text>
          {tutorialSteps.map((step, index) => (
            <View key={index} className="flex-row items-start gap-3">
              <View className="w-7 h-7 rounded-full bg-secondary-600 items-center justify-center shrink-0">
                <Text className="font-bold text-white text-sm">{index + 1}</Text>
              </View>
              <Text className="flex-1 text-base leading-normal">{step}</Text>
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

export default MeasurementIntroStep;
